module.exports = __webpack_public_path__ + "img/logo-aula.44b08339.png";